/* QUILTZA sepet çekmecesi eklentileri: hızlı ekle, numune, hediye paketi. Mevcut cart-drawer.js'i yeniden kullanır. */
(function () {
  if (window.__qzCart) return;
  window.__qzCart = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  function enqueue(fn) { queue = queue.then(fn, fn); return queue; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sections() {
    var d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function status(from, msg) {
    var box = from.closest('[data-qz-samples], qz-upsell, [data-qz-gift]');
    var el = box && box.querySelector('[data-qz-status]');
    if (el) el.textContent = msg || '';
  }
  function render(state) {
    if (document.getElementById('main-cart-items')) { window.location.reload(); return; }
    var d = drawer();
    if (d && state && state.sections) d.renderContents(state);
    else window.location.href = root + 'cart';
  }
  function busy(btn, on) {
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function addVariant(btn, id, properties) {
    var body = { items: [{ id: Number(id), quantity: 1, properties: properties || {} }], sections: sections(), sections_url: window.location.pathname };
    return post('cart/add.js', body).then(function (res) {
      if (res && res.status) { status(btn, res.description || res.message); busy(btn, false); return; }
      render(res);
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-qz-add]');
    if (add) {
      e.preventDefault();
      busy(add, true);
      enqueue(function () { return addVariant(add, add.dataset.qzAdd).catch(function () { busy(add, false); }); });
      return;
    }
    var sample = e.target.closest('[data-qz-sample]');
    if (sample) {
      e.preventDefault();
      if (sample.getAttribute('aria-pressed') === 'true') return;
      var wrap = sample.closest('[data-qz-samples]');
      var key = wrap && wrap.dataset.sampleKey;
      busy(sample, true);
      enqueue(function () {
        var step = key ? post('cart/change.js', { id: key, quantity: 0 }) : Promise.resolve();
        return step
          .then(function () { return addVariant(sample, sample.dataset.qzSample, { _qz_sample: '1' }); })
          .catch(function () { busy(sample, false); });
      });
    }
  });

  var timers = {};
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-qz-attr]');
    if (!el) return;
    e.stopPropagation();
    var name = el.dataset.qzAttr;
    var value = el.type === 'checkbox' ? (el.checked ? el.dataset.qzOn : '') : el.value;
    if (el.type === 'checkbox') {
      var ctrl = el.getAttribute('aria-controls');
      var panel = ctrl && document.getElementById(ctrl);
      if (panel) panel.hidden = !el.checked;
      if (!el.checked && panel) {
        var note = panel.querySelector('[data-qz-attr]');
        if (note && note.value) { note.value = ''; save(note.dataset.qzAttr, '', note); }
      }
    }
    save(name, value, el);
  }, true);

  function save(name, value, el) {
    clearTimeout(timers[name]);
    timers[name] = setTimeout(function () {
      var attrs = {};
      attrs[name] = value;
      enqueue(function () {
        return post('cart/update.js', { attributes: attrs })
          .then(function () { status(el, ''); })
          .catch(function () { status(el, window.cartStrings ? window.cartStrings.error : ''); });
      });
    }, 300);
  }

  /* Search & Discovery tamamlayıcı ürünler: çekmece açıldığında yüklenir */
  if (!customElements.get('qz-upsell')) {
    customElements.define('qz-upsell', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.source !== 'complementary' || !this.dataset.productId || this._done) return;
        var self = this;
        var run = function () {
          self._done = true;
          var url = root + 'recommendations/products?section_id=qz-upsell&intent=complementary&limit=6&product_id=' + encodeURIComponent(self.dataset.productId);
          fetch(url)
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (t) {
              if (!t) return;
              var doc = new DOMParser().parseFromString(t, 'text/html');
              var items = doc.querySelectorAll('[data-qz-upsell-result] > li');
              if (!items.length) return;
              var limit = parseInt(self.dataset.limit, 10) || 3;
              var list = self.querySelector('[data-qz-upsell-list]');
              list.innerHTML = '';
              Array.prototype.slice.call(items, 0, limit).forEach(function (li) { list.appendChild(li); });
              self.hidden = false;
            })
            .catch(function () {});
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (en) {
            if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); run(); }
          });
          io.observe(this.hidden ? this.parentElement : this);
        } else { run(); }
      }
    });
  }
})();
